<template>
    <dashboard-layout>
        <v-container fluid class="down-top-padding py-0">
            <BaseBreadcrumb
            :title="page.title"
            :icon="page.icon"
            :breadcrumbs="breadcrumbs"
            ></BaseBreadcrumb>
            <v-row dense>
                <v-col cols="12">
                    <table-report-daily-admin></table-report-daily-admin>
                </v-col>
            </v-row>
        </v-container>
    </dashboard-layout>
</template>

<script>
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
import TableReportDailyAdmin from './TableGrids/TableReportDailyAdmin.vue'

export default {
    name: 'ReportDailyAdmin',
    props: {

    },
    components: {
        DashboardLayout,
        BaseBreadcrumb,
        TableReportDailyAdmin,
    },
    data() {
        return {
            page: {
                title: "Daily Order Transactions",
            },
            breadcrumbs: [
                { text: "Daily Order Transactions", disabled: true },
            ],
        }
    },
    watch: {},
    computed: {},
    mounted: function () {},
    methods: {

    }
}
</script>

<style>

</style>
